import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: "2247ycht", // find this at manage.sanity.io or in your sanity.json
  dataset: "production", // this is from those question during 'sanity init'
  apiVersion: "2021-09-17",
  useCdn: true,
});
